import { useGqlQuery } from "@/lib/GraphQLCodegen/fetcher";
import {
  OrganisationRecord,
  organisationRecordQuery,
} from "@/app/Organisations/GraphQL/organisationRecordQuery";
import { useParams } from "@tanstack/react-router";

export function useOrganisationRecord(): OrganisationRecord {
  const { id } = useParams({ strict: false }) as { id: string };

  const { data } = useGqlQuery(organisationRecordQuery, { id });

  return data!.organisation;
}
